import { styled } from "styled-components";

export const ContactSectionWrapper = styled.div<{ $altBackground?: boolean }>`
  background: ${({ theme, $altBackground }) =>
    $altBackground
      ? `linear-gradient(to bottom, ${theme.colors.primary[950]} 45%, ${theme.colors.base} 45%)`
      : theme.colors.base};
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 24px 48px 24px;
  position: relative;
  margin-bottom: 100px;

  ${({ theme }) => theme.breakpoints.lg.query} {
    background: ${({ theme, $altBackground }) =>
      $altBackground
        ? `linear-gradient(to bottom, ${theme.colors.primary[950]} 25%, ${theme.colors.base} 25%)`
        : theme.colors.base};
    padding: 24px 24px 48px 24px;
    --split-point: 25%;
  }

  @media (min-width: 2400px) {
    background: ${({ theme, $altBackground }) =>
      $altBackground
        ? `linear-gradient(to bottom, ${theme.colors.primary[950]} 35%, ${theme.colors.base} 35%)`
        : theme.colors.base};
  }
`;

export const LeftColumn = styled.div`
  z-index: 1;
  min-height: 750px;
  display: flex;
  flex-direction: column;
  gap: 120px;

  ${({ theme }) => theme.breakpoints.lg.query} {
    min-height: 500px;
    align-items: center;
  }
`;

export const HeadingContainer = styled.div<{ $altBackground?: boolean }>`
  max-width: 580px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  color: ${({ theme, $altBackground }) =>
    $altBackground ? theme.colors.primary[50] : "currentColor"};

  > h2 {
    word-break: break-word;
  }
`;

export const ContactSectionContainer = styled.div<{ $fullWidth?: boolean }>`
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  width: 100%;
  gap: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;

  ${({ $fullWidth }) =>
    $fullWidth &&
    `
      flex-direction: column;
      align-items: center;
      justify-content: center;
    `}

  ${({ theme }) => theme.breakpoints.lg.query} {
    max-width: 800px;
    flex-direction: column;
    gap: 48px;
  }
`;

export const ContactSectionHeader = styled.div`
  color: ${({ theme }) => theme.colors.default[400]};
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
`;

export const ContactSectionContent = styled.div<{
  $fullWidth?: boolean;
  $altLayout?: boolean;
}>`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: ${({ $fullWidth }) => ($fullWidth ? "center" : "flex-start")};
  gap: 12px;
  width: ${({ $fullWidth }) => ($fullWidth ? "100%" : "45%")};
  color: ${({ theme, $fullWidth, $altLayout }) =>
    $fullWidth && $altLayout ? theme.colors.primary[0] : "currentColor"};
  overflow-wrap: break-word;
  word-break: break-word;
  > * {
    min-width: 0; /* ✅ prevents flex children from overflowing */
  }

  a {
    color: ${({ theme }) => theme.colors.primary.default};
  }

  ${({ theme }) => theme.breakpoints.lg.query} {
    width: 100%;
  }
`;

export const ContactSectionForm = styled.div<{ $fullWidth?: boolean }>`
  z-index: 2;
  width: ${({ $fullWidth }) => ($fullWidth ? "80%" : "45%")};
  align-self: ${({ $fullWidth }) => ($fullWidth ? "auto" : "end")};

  ${({ $fullWidth }) =>
    $fullWidth &&
    `
      display: flex;
      justify-content: center;
    `}

  ${({ theme }) => theme.breakpoints.lg.query} {
    width: 100%;
  }
`;

export const InfoBlocksContainer = styled.div`
  z-index: 1;
  max-width: 700px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: end;
  flex: 1;
  gap: 32px;

  ${({ theme }) => theme.breakpoints.sm.query} {
    margin-top: 80px;
  }
`;

export const InfoBulletsContainer = styled.div`
  color: ${({ theme }) => theme.colors.default[600]};

  div {
    color: ${({ theme }) => theme.colors.default[600]};
  }

  display: flex;
  max-width: 550px;
  padding-top: 24px;
  padding-bottom: 24px;
  gap: 12px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
`;

export const InfoBullets = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Arch = styled.div`
  z-index: 0;
  color: ${({ theme }) => theme.colors.base};
  overflow: hidden;
  position: absolute;
  bottom: 54%;
  left: 50%;
  transform: translateX(-50%);

  ${({ theme }) => theme.breakpoints.lg.query} {
    bottom: 74%;
  }

  @media (min-width: 2400px) {
    display: none;
  }
`;

export const BulletPointContainer = styled.div`
  display: flex;
  padding-top: 12px;
  padding-bottom: 12px;
  flex-direction: column;
  align-items: flex-start;
  max-height: 230px;
  max-width: 550px;
  gap: 8px;
  overflow-wrap: break-word; /* ✅ valid text wrapping */
  word-break: break-word;
  & > div {
    color: ${({ theme }) => theme.colors.default[600]};
  }

  ${({ theme }) => theme.breakpoints.sm.query} {
    max-height: 100%;
  }
`;
